export const NUMBER_OF_RECORDS_TO_EXPORT = 20000;

export const STAGE_LABELS = {
  staging: "Test",
  preview: "Preview",
  development: "Development",
};
